// @flow

export const DashboardSectionEnum = Object.freeze({
    LIVE_VIEW: 'live_view',
    BATCH: 'batch',
    PJP: 'pjp',
    INSIGHTS: 'insights',
    ENTITIES: 'entity',
    INTELLISORT: 'intellisort',
    QUOTATIONS: 'quotations',
    NETOPT_ENTITIES: 'netOptEntity',
    CONTRACTS: 'contracts',
    ROSTER: 'roster',
    MY_SETTINGS: 'mysettings'
});

export default DashboardSectionEnum;

export type DashboardSectionEnumType = $Values<typeof DashboardSectionEnum>;
